import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fd8c1be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-box" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScBtn',
  props: {
    danger: { type: Boolean },
    icon: {},
    text: {},
    tip: {},
    iconStyle: {},
    size: {},
    type: {},
    confirm: {},
    handler: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const loading = ref(false);

async function onClick() {
  if (!props.handler) {
    return;
  }
  loading.value = true;
  try {
    await props.handler();
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tooltip, { title: _ctx.tip }, {
      default: _withCtx(() => [
        (_ctx.confirm)
          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
              key: 0,
              title: _ctx.confirm,
              "ok-text": "确定",
              "cancel-text": "取消",
              onConfirm: onClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  style: {"display":"block"},
                  danger: _ctx.danger,
                  type: _ctx.type,
                  size: _ctx.size,
                  loading: loading.value,
                  disabled: _ctx.disabled
                }, {
                  icon: _withCtx(() => [
                    (_ctx.icon)
                      ? (_openBlock(), _createBlock(_component_sc_icon, {
                          key: 0,
                          type: _ctx.icon,
                          style: _normalizeStyle(_ctx.iconStyle)
                        }, null, 8, ["type", "style"]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
                  ]),
                  _: 1
                }, 8, ["danger", "type", "size", "loading", "disabled"])
              ]),
              _: 1
            }, 8, ["title"]))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              style: {"display":"block"},
              danger: _ctx.danger,
              type: _ctx.type,
              size: _ctx.size,
              onClick: onClick,
              loading: loading.value,
              disabled: _ctx.disabled
            }, {
              icon: _withCtx(() => [
                (_ctx.icon)
                  ? (_openBlock(), _createBlock(_component_sc_icon, {
                      key: 0,
                      type: _ctx.icon,
                      style: _normalizeStyle(_ctx.iconStyle)
                    }, null, 8, ["type", "style"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1),
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["danger", "type", "size", "loading", "disabled"]))
      ]),
      _: 3
    }, 8, ["title"])
  ]))
}
}

})